import { createElement } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { getBlockMenuDefaultClassName } from '@wordpress/blocks';
/**
 * Internal dependencies
 */

import InserterListItem from '../inserter-list-item';
import { InserterListboxGroup, InserterListboxRow } from '../inserter-listbox';

function chunk(array, size) {
  const chunks = [];

  for (let i = 0, j = array.length; i < j; i += size) {
    chunks.push(array.slice(i, i + size));
  }

  return chunks;
}

function BlockTypesList(_ref) {
  let {
    items = [],
    onSelect,
    onHover = () => {},
    children,
    label,
    isDraggable = true
  } = _ref;
  return createElement(InserterListboxGroup, {
    className: "block-editor-block-types-list",
    "aria-label": label
  }, chunk(items, 3).map((row, i) => createElement(InserterListboxRow, {
    key: i
  }, row.map((item, j) => createElement(InserterListItem, {
    key: item.id,
    item: item,
    className: getBlockMenuDefaultClassName(item.id),
    onSelect: onSelect,
    onHover: onHover,
    isDraggable: isDraggable,
    isFirst: i === 0 && j === 0
  })))), children);
}

export default BlockTypesList;
//# sourceMappingURL=index.js.map